module.exports = __webpack_public_path__ + "static/f-01-c1ee3be5812bee9be8a98f845af10177.svg";